import React from 'react'
import './ReaperHero.scss'

export class ReaperHero extends React.Component {
  render() {
    return (
      <div
        className="reaper-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="logo-wrap">
            <img src="/reaper-logo-1.png" alt="REAPER Logo" className="reaper-logo" />
          </div>
          <div className="text">
            <h1>REAPER</h1>
            <h2>AI Decision Advantage for Command and Control</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default ReaperHero
